import Page from "components/Page";
import { Props } from "./InvoiceCategoryTypes";
import { lazyWithRetry } from "helpers/lazyWithRetry";

const InvoiceCategoryTypes = lazyWithRetry(() =>
  import("./InvoiceCategoryTypes")
);

export default (props: Props) => (
  <Page>
    <InvoiceCategoryTypes {...props} />
  </Page>
);
